module.exports = __webpack_public_path__ + "static/media/Stroke-7.e4900077.woff";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/stroke7/fonts/Stroke-7.woff?f72xkr
// module id = 780
// module chunks = 0